import React from 'react';

import { OptionProps, components } from 'react-select';

import { Checkbox } from 'components/DesignSystem/Checkbox';

export const InputOption = <T,>({
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
}: OptionProps<T>) => {
    const style = {
        alignItems: 'center',
        backgroundColor: 'transparent',
        color: 'inherit',
        display: 'flex ',
        gap: '0.8rem',
    };

    // prop assignment
    const props = {
        ...innerProps,
        style,
    };

    return (
        <components.Option
            {...rest}
            isDisabled={isDisabled}
            isFocused={isFocused}
            isSelected={isSelected}
            getStyles={getStyles}
            innerProps={props}
        >
            <Checkbox checked={isSelected} />
            {children}
        </components.Option>
    );
};
